import React from 'react';
import styled, { keyframes } from 'styled-components';
import WhatsappIcon from '@components/icons/WhatsappIcon';
import { useRouter } from 'next/router';

const URL = 'https://wa.me';

const Whatsapp = ({ number, message, ...props }) => {
    const router = useRouter();
    const formattedNumber = number.replace(/[^\w\s]/gi, '').replace(/ /g, '');
    let url = `${URL}/${formattedNumber}`;

    const finalMessage = "Hello, I'm contacting you from ferventeshop.com.";

    if (finalMessage) {
        url += `?text=${encodeURI(finalMessage)}`;
    }

    const isCartOrCheckout =
        router.pathname === '/cart' ||
        router.pathname === '/checkout' ||
        router.pathname.includes('/product');

    return (
        <Wrapper
            type="button"
            onClick={() => {
                window.open(url);
                window.dataLayer.push({
                    event: 'wp_click',
                });
            }}
            isCartOrCheckout={isCartOrCheckout}
            {...props}
        >
            <Container>
                <WhatsappIcon />
                <Message>1</Message>
            </Container>
        </Wrapper>
    );
};

// Professional pulse animation for B2B
const pulseAnimation = keyframes`
    0% {
        transform: scale(1);
        box-shadow: 0 0 30px rgba(62, 195, 79, 0.6), 0 0 60px rgba(62, 195, 79, 0.3), 0 0 0 0 rgba(62, 195, 79, 0.7);
    }
    70% {
        transform: scale(1.02);
        box-shadow: 0 0 35px rgba(62, 195, 79, 0.7), 0 0 70px rgba(62, 195, 79, 0.4), 0 0 0 15px rgba(62, 195, 79, 0);
    }
    100% {
        transform: scale(1);
        box-shadow: 0 0 30px rgba(62, 195, 79, 0.6), 0 0 60px rgba(62, 195, 79, 0.3), 0 0 0 0 rgba(62, 195, 79, 0);
    }
`;

const Wrapper = styled.button`
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 999;
    background: #3ec34f;
    border: none;
    cursor: pointer;
    outline: none;
    border-radius: 50%;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    animation: ${pulseAnimation} 3s infinite;
    box-shadow: 0 0 30px rgba(62, 195, 79, 0.6), 0 0 60px rgba(62, 195, 79, 0.3);
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        transform: scale(1.08) translateY(-2px);
        animation: none;
        box-shadow: 0 0 40px rgba(62, 195, 79, 0.8),
            0 0 80px rgba(62, 195, 79, 0.5), 0 8px 25px rgba(62, 195, 79, 0.4);
        background: linear-gradient(135deg, #2a8f3a 0%, #3ec34f 100%);
    }

    &:active {
        transform: scale(0.95) translateY(0px);
        box-shadow: 0 2px 10px rgba(62, 195, 79, 0.4);
    }

    @media (max-width: 768px) {
        bottom: ${({ isCartOrCheckout }) =>
            isCartOrCheckout ? '180px' : '30px'};
        right: 15px;
        width: 55px;
        height: 55px;
    }
`;

const Container = styled.div`
    position: relative;
`;
const Message = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -2px;
    right: -2px;
    font-size: 10px;
    font-weight: 600;
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
    border: 2px solid #fff;
    box-shadow: 0 2px 8px rgba(231, 76, 60, 0.4);
    animation: bounce 2s infinite;

    @keyframes bounce {
        0%,
        20%,
        50%,
        80%,
        100% {
            transform: translateY(0);
        }
        40% {
            transform: translateY(-3px);
        }
        60% {
            transform: translateY(-2px);
        }
    }

    @media (max-width: 768px) {
        width: 16px;
        height: 16px;
        font-size: 9px;
    }
`;

export default Whatsapp;
